import { createSelector } from '@reduxjs/toolkit';
import type { GetCustomerSecuritiesRequestParams } from '@src/providers/AppStateProvider/streamingDataSlice';
import type { AppState } from '@src/providers/AppStateProvider/types';

export const selectSalesRFQCustomerSecuritiesRequestParams = createSelector(
  (state: AppState) => state.salesRFQ.form.customerField,
  (customerField): Partial<GetCustomerSecuritiesRequestParams> => {
    return {
      Counterparty: customerField.value?.Name,
    };
  }
);
